<template>
    <div class="d-inline">
        <b-button class="btn employee-filter-btn mb-1 custom-secodary-btn align-top mr-1 btn-secondary" variant="secondary" @click="$bvModal.show('penalty-processing-list')">
            Process Penalty
        </b-button>

        <b-modal id="penalty-processing-list" :title="modalTitle" size="lg" hide-footer @show="onModalShow">

            <b-overlay :show="processing">
                <div class="card-body p-0">
                    
                    <!-- STEP 1: Penalty Runs Selection -->
                    <div v-if="current_step === 1">
                        <p>Please select one or more penalty runs from the list below to process.</p>

                        <table class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table mt-3">
                            <tbody>
                                <tr class="table-head table-head-center">
                                    <td class="text-center checkbox-col">
                                        <input id="select-all-runs" type="checkbox" v-model="selectAllRuns"/>
                                        <label for="select-all-runs"></label>
                                    </td>
                                    <td class="text-left">Penalty Run (Month / Year)</td>
                                    <td class="text-right">Total Employees</td>
                                </tr>

                                <tr v-if="approved_runs.length === 0">
                                    <td colspan="5" class="text-center text-muted py-4">
                                        No approved penalty runs found.
                                    </td>
                                </tr>

                                <tr
                                    class="table-row hover-bg"
                                    v-for="run in approved_runs"
                                    :key="run.id"
                                >
                                    <td class="text-center checkbox-col">
                                        <input
                                            :id="'run-checkbox-' + run.id"
                                            type="checkbox"
                                            v-model="selected_run_ids"
                                            :value="String(run.id)"
                                        />
                                        <label :for="'run-checkbox-' + run.id"></label>
                                    </td>
                                    <td class="align-middle text-left">
                                        {{ run.month_label }} {{ run.year }}
                                    </td>
                                    <td class="align-middle text-right">
                                        {{ run.total_employees }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="d-flex justify-content-end mt-3">
                            <button
                                class="btn btn-primary"
                                :disabled="selected_run_ids.length === 0 || processing"
                                @click="goToNextStep"
                            >
                                Next
                                <b-icon icon="arrow-right-short" class="ml-1"></b-icon>
                            </button>
                        </div>
                    </div>

                    <!-- STEP 2: Employees Selection & Processing -->
                    <div v-if="current_step === 2">
                        <div v-if="penalty_ids.length > 0">
                            Selected Employee(s): {{ penalty_ids.length }}
                        </div>

                        <p>
                            Please select employee(s) to process penalty in bulk or process penalty
                            for an individual employee through the action column.
                        </p>

                        <div class="align-self-center custom-search pr-0 mt-2 w-50">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>

                                <b-form-input
                                    type="search"
                                    placeholder="Search employee"
                                    v-model="this_search_two"
                                    @input="resetPaginationTwo"
                                ></b-form-input>
                            </b-input-group>
                        </div>

                        <table class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table mt-3">
                            <tbody>
                                <tr class="table-head table-head-center">
                                    <td class="text-center checkbox-col">
                                        <input
                                            id="select-all-penalty"
                                            type="checkbox"
                                            v-model="selectAll"
                                        />
                                        <label for="select-all-penalty"></label>
                                    </td>
                                    <td class="text-left">Name</td>
                                    <td class="text-right">Salary Deduct</td>
                                    <td class="text-center">Salary Type</td>
                                    <td class="text-center">Status</td>
                                    <td class="text-right">Action</td>
                                </tr>

                                <tr v-if="paginatedDataTwo.length === 0">
                                    <td colspan="6" class="text-center text-muted py-4">
                                        No records found.
                                    </td>
                                </tr>

                                <tr
                                    class="table-row hover-bg"
                                    v-for="employee in paginatedDataTwo"
                                    :key="employee.employee_id"
                                >
                                    <td class="text-center checkbox-col">
                                        <input
                                            :id="'penalty-checkbox-' + employee.employee_id"
                                            type="checkbox"
                                            v-model="penalty_ids"
                                            name="penalty_ids[]"
                                            :value="JSON.stringify(employee.penalty_id)"
                                        />
                                        <label :for="'penalty-checkbox-' + employee.employee_id"></label>
                                    </td>

                                    <td class="align-middle">
                                        <span>
                                            {{ employee.employee_name }}
                                        </span>

                                        <small class="d-block text-muted">
                                            Code: {{ employee.employee_code }} <span v-if="employee.month_label">| Run: {{ employee.month_label }} {{ employee.year }}</span>
                                        </small>
                                    </td>

                                    <td class="align-middle text-right">
                                        {{ employee.salary_deduct }}
                                    </td>

                                    <td class="align-middle text-center">
                                        {{ salaryTypeLabel(employee.salary_type) }}
                                    </td>

                                    <td class="align-middle text-center">
                                        <span v-if="employee.payrun_id != null">Processed</span>
                                        <span v-else>Not Processed</span>
                                    </td>

                                    <td class="align-middle text-right position-relative">
                                        <a
                                            :id="'actionDropdown-' + employee.penalty_id"
                                            class="dropdown-toggle clearfix action-dropdown-toggle"
                                            href="#"
                                            role="button"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <b-icon icon="three-dots-vertical"></b-icon>
                                        </a>

                                        <div
                                            class="dropdown-menu action-dropdown-menu px-1"
                                            :aria-labelledby="'actionDropdown-' + employee.penalty_id"
                                        >
                                            <button
                                                v-if="employee.payrun_id == null"
                                                class="btn btn-primary float-right"
                                                @click="processSinglePenalty(employee.penalty_id)"
                                            >
                                                <b-icon icon="gear" class="mr-2 mt-n1" scale="1"></b-icon>
                                                Process Penalty
                                            </button>
                                            <button
                                                v-else
                                                class="btn btn-secondary float-right"
                                                @click="unprocessSinglePenalty(employee.penalty_id)"
                                            >
                                                <b-icon icon="arrow-counterclockwise" class="mr-2 mt-n1" scale="1"></b-icon>
                                                Undo Process Penalty
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tfoot>
                                <tr v-if="paginatedDataTwo.length > 0">
                                    <td colspan="100">
                                        <div class="row py-2">
                                            <div class="col-md-12 p-0 no-margin">
                                                <ul class="pagination b-pagination float-left">
                                                    <li class="page-item disabled m-2">View</li>

                                                    <li class="page-item disabled">
                                                        <b-form-select
                                                            v-model="temp_length"
                                                            :options="length_options"
                                                            @change="setFirstPageTwo"
                                                        ></b-form-select>
                                                    </li>

                                                    <li class="page-item disabled m-2">
                                                        per page. Total {{ filteredPenaltyList.length }} records found.
                                                    </li>
                                                </ul>

                                                <b-pagination-nav
                                                    class="float-right"
                                                    v-model="this_pagination_two.currentPage"
                                                    :number-of-pages="this_pagination_two.pages"
                                                    base-url="#"
                                                    first-number
                                                    last-number
                                                ></b-pagination-nav>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>

                        <div class="d-flex justify-content-between mt-3">
                            <div>
                                <button
                                    class="btn btn-secondary mr-2"
                                    :disabled="processing"
                                    @click="current_step = 1"
                                >
                                    <b-icon icon="arrow-left-short" class="mr-1"></b-icon>
                                    Back
                                </button>
                            </div>
                            <div>
                                <button
                                    class="btn btn-secondary mr-2"
                                    :disabled="penalty_ids.length === 0 || processing"
                                    @click="unprocessPenalty(null)"
                                >
                                    Undo Process (selected)
                                </button>
                                <button
                                    class="btn btn-primary"
                                    :disabled="penalty_ids.length === 0 || processing"
                                    @click="processPenalty(null)"
                                >
                                    Process (selected)
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['payrun_id'],

    data() {
        return {
            months: {
                January: "01",
                February: "02",
                March: "03",
                April: "04",
                May: "05",
                June: "06",
                July: "07",
                August: "08",
                September: "09",
                October: "10",
                November: "11",
                December: "12",
            },
            processing: false,
            download_text: 'Processing penalty. Please wait...',

            penalty_list: [],
            approved_runs: [],
            penalty_ids: [],

            current_step: 1,
            selected_run_ids: [],

            this_search_two: '',
            temp_length: 10,

            length_options: [
                { value: 10, text: '10' },
                { value: 25, text: '25' },
                { value: 50, text: '50' },
                { value: 100, text: '100' },
            ],

            this_pagination_two: {
                currentPage: 1,
                pages: 1,
            },
        };
    },

    computed: {
        modalTitle() {
            return this.current_step === 1 
                ? "Select Penalty Run(s) for Processing" 
                : "Employee List for Penalty Processing";
        },

        filteredPenaltyList() {
            const search = String(this.this_search_two || '').toLowerCase().trim();

            if (!search) {
                return this.penalty_list;
            }

            return this.penalty_list.filter((item) => {
                const employeeName = String(item.employee_name || '').toLowerCase();
                const employeeId = String(item.employee_id || '').toLowerCase();
                const employeeCode = String(item.employee_code || '').toLowerCase();

                return (
                    employeeName.includes(search) ||
                    employeeId.includes(search) ||
                    employeeCode.includes(search)
                );
            });
        },

        paginatedDataTwo() {
            const total = this.filteredPenaltyList.length;
            const perPage = parseInt(this.temp_length, 10) || 10;

            this.this_pagination_two.pages = Math.max(Math.ceil(total / perPage), 1);

            if (this.this_pagination_two.currentPage > this.this_pagination_two.pages) {
                this.this_pagination_two.currentPage = 1;
            }

            const start = (this.this_pagination_two.currentPage - 1) * perPage;
            const end = start + perPage;

            return this.filteredPenaltyList.slice(start, end);
        },

        selectablePenaltyIds() {
            return this.filteredPenaltyList
                .map((item) => JSON.stringify(item.penalty_id));
        },

        selectAll: {
            get() {
                if (this.selectablePenaltyIds.length === 0) {
                    return false;
                }

                return this.selectablePenaltyIds.every((id) => {
                    return this.penalty_ids.includes(id);
                });
            },

            set(value) {
                if (value) {
                    this.penalty_ids = [
                        ...new Set([
                            ...this.penalty_ids,
                            ...this.selectablePenaltyIds,
                        ]),
                    ];
                } else {
                    this.penalty_ids = this.penalty_ids.filter((id) => {
                        return !this.selectablePenaltyIds.includes(id);
                    });
                }
            },
        },

        selectableRunIds() {
            return this.approved_runs.map((item) => String(item.id));
        },

        selectAllRuns: {
            get() {
                if (this.selectableRunIds.length === 0) {
                    return false;
                }

                return this.selectableRunIds.every((id) => {
                    return this.selected_run_ids.includes(id);
                });
            },

            set(value) {
                if (value) {
                    this.selected_run_ids = [...this.selectableRunIds];
                } else {
                    this.selected_run_ids = [];
                }
            },
        },
    },

    methods: {
        resetPaginationTwo() {
            this.this_pagination_two.currentPage = 1;
        },

        setFirstPageTwo() {
            this.this_pagination_two.currentPage = 1;
        },

        salaryTypeLabel(type) {
            if (Number(type) === 0) {
                return 'Basic';
            }

            if (Number(type) === 1) {
                return 'Gross';
            }

            return 'N/A';
        },

        onModalShow() {
            this.current_step = 1;
            this.selected_run_ids = [];
            this.penalty_list = [];
            this.penalty_ids = [];
            this.getPenaltyRunList();
        },

        getPenaltyRunList() {
            this.processing = true;
            this.download_text = 'Loading penalty runs list...';
            axios.get(this.$api_url + '/leave-attendance/penalty-runs/list/approved').then(function (response) {
                this.approved_runs = response.data;
                this.processing = false;
            }.bind(this)).catch(function (error) {
                this.serverError(error);
                this.processing = false;
            }.bind(this));
        },

        goToNextStep() {
            if (this.selected_run_ids.length === 0) {
                return;
            }
            this.loadPenaltyListForSelectedRuns().then((success) => {
                if (success) {
                    this.current_step = 2;
                }
            });
        },

        loadPenaltyListForSelectedRuns() {
            this.processing = true;
            this.download_text = 'Loading employee penalty list...';

            let formData = new FormData();
            formData.append('payrun_id', this.payrun_id);
            formData.append('penalty_run_ids', JSON.stringify(this.selected_run_ids));

            return axios.post(this.$api_url + '/leave-attendance/penalty/salary-summary', formData)
                .then(response => {
                    this.penalty_list = response.data || [];
                    this.penalty_ids = [];
                    this.resetPaginationTwo();
                    return true;
                })
                .catch(error => {
                    this.serverError(error);
                    return false;
                })
                .finally(() => {
                    this.processing = false;
                });
        },

        processPenalty(selected_ids = null) {
            const idsToProcess = selected_ids || this.penalty_ids;
            if (idsToProcess.length === 0) {
                this.$bvToast.toast('Please select at least one employee.', {
                    title: 'Warning',
                    variant: 'warning',
                    solid: true,
                });

                return;
            }

            this.processing = true;
            this.download_text = 'Processing selected penalty...';

            const flatIds = idsToProcess.map(item => {
                try {
                    return JSON.parse(item);
                } catch (e) {
                    return item;
                }
            }).flat().map(Number);

            const formData = new FormData();
            formData.append('ids', JSON.stringify(flatIds));
            formData.append('payrun_id', this.payrun_id); // overtime/penalty process update: Sohel

            axios.post(this.$api_url + '/leave-attendance/penalty/salary/settle', formData).then((response) => {
                    this.$bvToast.toast(response.data.message || 'Penalty processed successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                    });

                    this.loadPenaltyListForSelectedRuns();
                })
                .catch((error) => {
                    this.serverError(error);
                })
                .finally(() => {
                    this.processing = false;
                });
        },

        processSinglePenalty(penalty_id) {
            this.processPenalty([JSON.stringify(penalty_id)]);
        },

        unprocessPenalty(selected_ids = null) {
            const idsToUnprocess = selected_ids || this.penalty_ids;
            if (idsToUnprocess.length === 0) {
                this.$bvToast.toast('Please select at least one employee.', {
                    title: 'Warning',
                    variant: 'warning',
                    solid: true,
                });

                return;
            }

            this.processing = true;
            this.download_text = 'Unprocessing selected penalty...';

            const flatIds = idsToUnprocess.map(item => {
                try {
                    return JSON.parse(item);
                } catch (e) {
                    return item;
                }
            }).flat().map(Number);

            const formData = new FormData();
            formData.append('ids', JSON.stringify(flatIds));
            formData.append('payrun_id', this.payrun_id); // overtime/penalty process update: Sohel

            axios.post(this.$api_url + '/leave-attendance/penalty/salary/unsettle', formData).then((response) => {
                    this.$bvToast.toast(response.data.message, {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                    });

                    this.loadPenaltyListForSelectedRuns();
                })
                .catch((error) => {
                    this.serverError(error);
                })
                .finally(() => {
                    this.processing = false;
                });
        },

        unprocessSinglePenalty(penalty_id) {
            this.unprocessPenalty([JSON.stringify(penalty_id)]);
        },
    },
};
</script>